import { Button } from "@/components/ui/button";
import { ArrowLeft, Home } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

interface AppHeaderProps {
  title: string;
  subtitle?: string;
  showHomeButton?: boolean;
  showBackButton?: boolean;
  rightContent?: React.ReactNode;
}

const AppHeader = ({ 
  title, 
  subtitle, 
  showHomeButton = true, 
  showBackButton = false,
  rightContent 
}: AppHeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleHomeClick = () => {
    // Determine home route based on current path and authentication
    if (location.pathname.includes('super-admin') || location.pathname.includes('cook')) {
      // Check if user is authenticated as super admin
      const isAuthenticated = localStorage.getItem('superAdminAuth') === 'true';
      if (isAuthenticated) {
        navigate('/super-admin');
      } else {
        navigate('/');
      }
    } else if (location.pathname.includes('host')) {
      // Check if user is authenticated as host
      const isAuthenticated = localStorage.getItem('hostAuth') === 'true';
      if (isAuthenticated) {
        navigate('/host-dashboard');
      } else {
        navigate('/');
      }
    } else {
      navigate('/');
    }
  };

  const handleBackClick = () => {
    window.history.back();
  };

  return (
    <div className="flex justify-between items-center mb-8">
      <div className="flex items-center gap-4">
        {showBackButton && (
          <Button 
            variant="outline" 
            size="sm"
            onClick={handleBackClick}
            className="text-primary hover:bg-primary/10"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
        )}
        <div>
          <div className="flex items-center gap-3">
            <h1 className="text-4xl font-bold text-neon">{title}</h1>
            {showHomeButton && (
              <Button 
                variant="outline" 
                size="sm"
                onClick={handleHomeClick}
                className="text-primary hover:bg-primary/10"
              >
                <Home className="h-4 w-4 mr-2" />
                Home
              </Button>
            )}
          </div>
          {subtitle && (
            <p className="text-xl text-muted-foreground">{subtitle}</p>
          )}
        </div>
      </div>
      {rightContent && (
        <div className="flex gap-4">
          {rightContent}
        </div>
      )}
    </div>
  );
};

export default AppHeader;